import React from "react";
import "./Description.css";
import MapLocation from "./MapLocation";

function Description({ description, location }) {
  return (
    <div className="col-md-7 col-sm-12">
      <div className="description-detail">
        <h2>İlan Açıklaması</h2>
        <div dangerouslySetInnerHTML={{ __html: description }}></div>
        <div className="location-section">
          <MapLocation location={location} />
        </div>
      </div>
    </div>
  );
}

export default Description;
